// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b0fbd73d","450":"6b48ff80","453":"5d3099ba","671":"d4e98c1c","716":"4807d8e6","739":"e8a6bb60","862":"aefe6d4a","910":"f8da3c7b"}[chunkId] + ".chunk.js";
};